import type { NavigationItem } from '@features/profile/components/side-navigation/NavigationItems.types';

import { useHasPermission } from '@contexts/permissions-provider';
import { navigationItems } from '@features/profile/components/side-navigation/NavigationItems';

function useVisibleProfileNavigationItems(): NavigationItem[] {
  const canViewProfileTraining = useHasPermission('ProfilePersonalTraining_FullAccess_Own');
  const canViewProfileBasic = useHasPermission('ProfilePersonalBasic_FullAccess_Own');
  const canViewNotifications = useHasPermission('ProfileNotifications_FullAccess_Own');
  const canViewPassword = useHasPermission('ProfilePassword_FullAccess_Own');

  const permissionMap: Record<string, boolean> = {
    ProfilePersonalTraining_FullAccess_Own: canViewProfileTraining,
    ProfilePersonalBasic_FullAccess_Own: canViewProfileBasic,
    ProfileNotifications_FullAccess_Own: canViewNotifications,
    ProfilePassword_FullAccess_Own: canViewPassword,
  };

  return navigationItems.filter(item => {
    const checks = item.requiredPermissions.map(p => permissionMap[p] ?? false);
    return item.operator === 'some' ? checks.some(Boolean) : checks.every(Boolean);
  });
}

export { useVisibleProfileNavigationItems };
